import {useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
const getCountryDialCode = (country) => {
  const dialCodeMap = {
    "Singapore": "+65",
    "Malaysia": "+60",
    "Hong Kong": "+852",
    "Taiwan": "+886",
    "Middle East": "+971", // Commonly UAE, can be adjusted
    "Philippines": "+63",
    "Myanmar": "+95",
    "Sri Lanka": "+94",
    "India": "+91",
  };

  return dialCodeMap[country] || "";
};

function ContactInput({ country,getValues,register, setValue, errors }) {

const { t } = useTranslation();


  return (
   <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="contact" className="form-label">{t("Contact Number")}</label>
                            <input type="text" id="contact" placeholder={getCountryDialCode(country)}  {...register("contact")} className="form-control" />
                            <p className="text-danger biodata">{errors.contact?.message}</p>
                        </div>
                    </div>
  );
}
ContactInput.propTypes = {
    register: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    control: PropTypes.object.isRequired,
    getValues: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    country: PropTypes.string.isRequired,
};
export default ContactInput;
